import { Location } from "./location";
export class LocationDetailsModel extends Location {
  brandName: string;
  planName: string;
  brandLogo: string;
}
